import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import BuildExpiryGate from 'app/security/build-expiry-gate';
import './cms/cms-app.css';
import IframeCmsShell from './iframe/IframeCmsShell';
import StandaloneCmsShell from './iframe/StandaloneCmsShell';
function isEmbeddedInIframe() {
    try {
        return typeof window !== 'undefined' && window.self !== window.top;
    }
    catch {
        return true;
    }
}
const embedded = isEmbeddedInIframe();
createRoot(document.getElementById('root')).render(_jsx(BuildExpiryGate, { children: _jsx(HashRouter, { children: _jsx("div", { className: embedded ? 'cms-mfe-iframe-root' : 'cms-mfe-standalone-root', children: embedded ? _jsx(IframeCmsShell, {}) : _jsx(StandaloneCmsShell, {}) }) }) }));
